import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL";
import { Button, Row, Col } from "react-bootstrap";

const VendorSubmissions = () => {
  const navigate = useNavigate();
  const { id, productid } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [productInput, setProductInput] = useState({
    proposed_mrp: "",
    advance_payment: "",
    model_name: "",
    model_details: "",
    images: "",
  });

  const fetchAssignments = async () => {
    try {
      const response = await axios.get(`${baseURL}/vendor/${id}/submissions`);
      const assignments = response.data.data || [];
      setData(assignments);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching vendor assignments:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAssignments();
  }, [id]);

  if (loading) return <p>Loading...</p>;

  return (
    <div className="main-container">
      <div className="payments-table-container">
        <Row className="mb-3">
          <Col className="d-flex justify-content-between align-items-center">
            <h3>Submissions of vendor</h3>
            <Button
              className="create_but"
              onClick={() => navigate("/orderstable")}
              style={{ backgroundColor: "#a36e29", borderColor: "#a36e29" }}
            >
              ← Back
            </Button>
          </Col>
        </Row>

        <div style={{ overflowX: "auto" }}>
          <table className="table table-bordered">
            <thead className="thead-light">
              <tr>
                <th>Bar Code</th>
                <th>Product Name</th>
                <th>Metal Type</th>
                <th>Purity</th>
                <th>Gross Wt</th>
                <th>Stone Wt</th>
                <th>W.Wt</th>
                <th>Total Wt</th>
                <th>Size</th>
                <th>MC</th>
                <th>Rate</th>
                <th>Tax Amt</th>
                <th>Total Price</th>
                <th>Model name</th>
                <th>Model details</th>
                <th>Proposed MRP</th>
                <th>Advance Payment</th>
                <th>Edit</th>
              </tr>
            </thead>
            <tbody>
              {data.map((product, index) => (
                <tr key={index}>
                  <td>{product.code}</td>
                  <td>{product.product_name}</td>
                  <td>{product.metal_type}</td>
                  <td>{product.purity}</td>
                  <td>{product.gross_weight}</td>
                  <td>{product.stone_weight}</td>
                  <td>{product.wastage_weight}</td>
                  <td>{product.total_weight_av}</td>
                  <td>{product.size}</td>
                  <td>{product.making_charges}</td>
                  <td>{product.rate}</td>
                  <td>{product.tax_amt}</td>
                  <td>{product.total_price}</td>
                  <td>{product.model_name}</td>
                  <td>{product.model_details}</td>
                  <td>{product.proposed_mrp}</td>
                  <td>{product.advance_payment}</td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      style={{ padding: "2px 6px", fontSize: "14px" }}
                      onClick={() =>
                        navigate(
                          `/vendor/${id}/assignments/${product.id}`
                        )
                      }
                    >
                      Edit
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VendorSubmissions;
